/**
 * FilterAutocomplete class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CustomAutocomplete from 'Common/CustomAutocomplete';
import { DataTableSelectType } from 'Types';

export default class FilterAutocomplete extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loadOptions: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(DataTableSelectType),
        setFilter: PropTypes.func.isRequired,
        multi: PropTypes.bool,
        placeholder: PropTypes.string,
        libraryParams: PropTypes.object,
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        multi: false,
        libraryParams: {},
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    handleChange = value => {
        const { multi, setFilter } = this.props;

        if (multi) {
            setFilter(value && value.length ? { inq: value } : null);
        } else {
            setFilter(value);
        }
    };

    handleInputChange = (inputValue) => {
        const { loadOptions } = this.props;
        loadOptions(inputValue);
    };

    render() {
        const { options, multi, placeholder, ...libraryParams } = this.props;
        const { intl: { formatMessage } } = this.context;

        return (
            <CustomAutocomplete
                options={ [...options] }
                isMulti={ multi }
                isClearable
                placeholder={ placeholder ? formatMessage({ id: placeholder }) : '' }
                { ...libraryParams }
                onInputChange={ this.handleInputChange }
                onChange={ this.handleChange }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filters/FilterAutocomplete.jsx